import { LANGUAGE } from '../../constants/shared/CommonConstants';
import { GRADE } from '../../constants/shared/GradesConstants';
import { MEASURE, SKILLS } from '../../constants/shared/MeasuresConstants';

const { ENGLISH, SPANISH } = LANGUAGE;
const { FIRST_GRADE, SECOND_GRADE, THIRD_GRADE } = GRADE;

const {
    MAZE,
    NWF_CLS,
    NWF_WRC,
    ORF,
    ORF_ACC,
    PSF,
    TRC,
    VOCABO,
    WRF,
    LNF,
    FEP,
    FLO,
    FLO_PREC,
    FSL,
    FSS,
    LSS,
    CLPL,
    FNL,
} = MEASURE;
const {
    TRC: TRC_SKILL,
    VOCABO: VOCABO_SKILL,
    BASIC_COMPREHENSION,
    DECODING,
    LETTER_NAMES,
    LETTER_SOUNDS,
    PHONOLOGICAL_AWARENESS,
    READING_ACCURACY,
    READING_FLUENCY,
    WORD_READING,
} = SKILLS;

const SKILL_APP_MEASURES_MAPPER = {
    [LETTER_NAMES]: {
        [ENGLISH]: LNF,
        [SPANISH]: FNL,
        excludedGrades: [SECOND_GRADE, THIRD_GRADE],
    },
    [PHONOLOGICAL_AWARENESS]: {
        [ENGLISH]: PSF,
        [SPANISH]: FSS,
        excludedGrades: [SECOND_GRADE, THIRD_GRADE],
    },
    [LETTER_SOUNDS]: { [ENGLISH]: NWF_CLS, [SPANISH]: FSL, excludedGrades: [] },
    [DECODING]: { [ENGLISH]: NWF_WRC, [SPANISH]: LSS, excludedGrades: [] },
    [WORD_READING]: { [ENGLISH]: WRF, [SPANISH]: FEP, excludedGrades: [] },
    [READING_ACCURACY]: { [ENGLISH]: ORF_ACC, [SPANISH]: FLO_PREC, excludedGrades: [] },
    [READING_FLUENCY]: { [ENGLISH]: ORF, [SPANISH]: FLO, excludedGrades: [] },
    [BASIC_COMPREHENSION]: { [ENGLISH]: MAZE, [SPANISH]: CLPL, excludedGrades: [FIRST_GRADE] },
    [TRC_SKILL]: { [ENGLISH]: TRC, [SPANISH]: TRC, excludedGrades: [] },
    [VOCABO_SKILL]: { [ENGLISH]: VOCABO, [SPANISH]: VOCABO, excludedGrades: [] },
};

export default SKILL_APP_MEASURES_MAPPER;
